import React from 'react';
import FeedHeader from "./FeedHeader";
import FeedContent from "./FeedContent";
import FeedFooter from "./FeedFooter";
import Card from "@material-ui/core/Card";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(() => ({
    container: {
        margin: '20px 0'
    }
}));

const FeedItem = ({item, onClickLike, onClickLikeNumber, openFeedPost, editFeedPost, userId}) => {
    const classes = useStyles();
    return (
        <Card className={classes.container}>
            <FeedHeader
                author={item.author}
                uniqueUsers={item.uniqueUsers}
                userId={userId}
                createDate={item.createDate}
                editFeedPost={editFeedPost}
            />
            <Divider/>
            <FeedContent
                content={item.content}
            />
            <Button
                variant={"text"} color={"primary"}
                onClick={openFeedPost}
                style={{margin: 5}} size={"small"}
            >
                Read more
            </Button>
            <Divider/>
            <FeedFooter
                like={item.like}
                userId={userId}
                comments={item.comments}
                onClickLikeNumber={onClickLikeNumber}
                openFeedPost={openFeedPost}
                onClickLike={onClickLike}
            />
        </Card>
    )
};
export default FeedItem